import React from "react";
import Ingredient from "../Ingredient";
import raw from "../../assets/images/ingredients/RawPatty.png";
import cooked from "../../assets/images/ingredients/CookedPatty.png";

const Patty = ({ onClick, changeable=true, changed, hideable=true }) => {
    return (
        <Ingredient
            name="Patty"
            image={[raw, cooked]}
            changeable={changeable}
            changed={changed}
            hideable={hideable}
            onClick={onClick}
        />
    );
};

export default Patty;